var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddColBefore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon",
    style: {
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      fill: "#68688a",
      overflow: "hidden"
    },
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M810.666667 597.333333a213.333333 213.333333 0 1 1 0 426.666667 213.333333 213.333333 0 0 1 0-426.666667z m106.666666 253.354667a39.978667 39.978667 0 1 0 0-80h-53.333333a13.312 13.312 0 0 1-13.354667-13.354667V704a39.978667 39.978667 0 1 0-80 0v53.333333c0 7.381333-5.973333 13.354667-13.312 13.354667H704a39.978667 39.978667 0 1 0 0 80h53.333333c7.381333 0 13.354667 5.973333 13.354667 13.312v53.333333a39.978667 39.978667 0 1 0 80 0v-53.333333c0-7.381333 5.973333-13.354667 13.312-13.354667h53.333333zM85.333333 810.666667a128 128 0 0 0 256 0V213.333333a128 128 0 1 0-256 0v597.333334z m-85.333333 0V213.333333a213.333333 213.333333 0 1 1 426.666667 0v597.333334a213.333333 213.333333 0 0 1-426.666667 0z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddColBefore);
export default __webpack_public_path__ + "static/media/add_col_before.9348e7a0175f6ff29ccf4222b0abf3c4.svg";
export { ForwardRef as ReactComponent };